import * as React from 'react'
import { TeamNameWidgetConnected } from './TeamNameWidgetConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TeamNameWidgetExamples = () => {
  return (
    <div className="TeamNameWidgetExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TeamNameWidgetConnected />
      </Provider>
    </div>
  )
}
